import { connect } from "react-redux";

import { planAccepted, planDeclined } from "../../../store/plan/actions";
import { get } from "../../../actions/general";

import Notifications from "./loadable";

const mapDispatchToProps = { get, planAccepted, planDeclined };

export default connect(null, mapDispatchToProps)(Notifications);
